import React, { useState, useContext } from 'react';
import { Box, Button, Flex, Text, theme, Modal } from '@xometry/xometry_loft';
import { css } from '@emotion/react';
import InvitePanel from '../InvitePanel';
import NotificationContext from '../../../contexts/Notification';
import { AuthContext } from '@xometry/auth-context';

interface InviteButtonProps {
  orgName: string | undefined;
  orgId: number | undefined;
  hasWriteOrgPermission: boolean;
  onOnboardingActionCompleted: () => void;
}

const InviteButtons = (props: InviteButtonProps) => {
  const { orgName, orgId, hasWriteOrgPermission, onOnboardingActionCompleted } =
    props;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { addNotification } = useContext(NotificationContext);
  const { user, isStaff } = useContext(AuthContext);

  const onSuccess = (inviteCount: number) => {
    setIsModalOpen(false);
    addNotification(
      'success',
      `${inviteCount} Invitation${inviteCount > 1 ? 's' : ''} sent!`
    );
    onOnboardingActionCompleted();
  };
  const onError = () => {
    addNotification('danger', 'There was an error sending invitations.');
  };
  const modalOpen = () => {
    setIsModalOpen(true);
    if (window.analytics && user) {
      window.analytics.track('Invite team members clicked', {
        isStaff: isStaff(),
        userId: user.id,
        OrganizationId: orgId,
        email: user.emailAddress,
      });
    }
  };
  if (hasWriteOrgPermission) {
    return (
      <>
        <Box>
          <Flex
            className="invite-button-wrapper"
            justifyContent="space-between"
            paddingBottom={theme.space[6]}
            css={css`
              flex-direction: column;
              @media (min-width: 1024px) {
                flex-direction: row;
              }
            `}
          >
            <Flex
              flexDirection={'column'}
              gap={theme.space[3]}
              height="fit-content"
              css={css`
                gap: ${theme.space[3]};
              `}
            >
              {/* This can be uncommented when we have invite links with shareable functionality
            <Button
              kind="outline-blue"
              scale={theme.scale.small}
              width="max-content"
            >
              <i className="fas fa-link" />
              &nbsp; Copy Invite Link
            </Button> */}
              {
                <Button
                  kind={theme.kind.primary}
                  scale={theme.scale.small}
                  width="max-content"
                  onClick={modalOpen}
                >
                  Invite Team Members
                </Button>
              }
            </Flex>
          </Flex>
        </Box>
        <Modal
          showClose
          disableCloseOnClick
          title={<Text kind="panel-title">&nbsp;</Text>}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          breakpointMaxWidth="620px"
        >
          <Box padding={theme.space[6]}>
            <InvitePanel
              orgName={orgName}
              orgId={orgId}
              onSuccess={onSuccess}
              onError={onError}
            />
          </Box>
        </Modal>
      </>
    );
  } else {
    return <></>;
  }
};

export default InviteButtons;
